<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {usePiniaStore} from "../../store/pinia_store";

const props = defineProps({
    hasCartLines: {
        type: Boolean,
        required: true,
    },
    cartTotal: {
        type: Number,
        required: true,
    }
});

const piniaStore = usePiniaStore();

const receiveGiftText = window.Drupal.t('Receive a gift');
const minimumText = window.Drupal.t('With an order of at <strong>least</strong>');
const minSpendText = ref('');

const differenceCartAndMinOrderValue = computed(() => {
    if (!props.hasCartLines) {
        return 0;
    }

    return piniaStore.gifts.min_order_value - props.cartTotal;
});

const currencyFormatter = (value) => {
    return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(value / 100)
}

watch(differenceCartAndMinOrderValue, () => {
    minSpendText.value = window.Drupal.t('Spend @amount or more and receive a surprise', {'@amount': currencyFormatter(differenceCartAndMinOrderValue.value)})
})

onMounted(() => {
    minSpendText.value = window.Drupal.t('Spend @amount or more and receive a surprise', {'@amount': currencyFormatter(differenceCartAndMinOrderValue.value)});
})
</script>

<template>
    <div class="vue-no-gift-alert row">
        <div class="col-12">
            <div class="alert d-flex align-items-center">
                <div class="icon icon-info"></div>
                <div class="alert-content">
                    <p><span class="font-weight-bold">{{ receiveGiftText }}</span></p>
                    <p>
                        <span v-html="minimumText"></span>
                        <strong>

                            {{ currencyFormatter(piniaStore.gifts.min_order_value) }}
                        </strong>
                    </p>
                </div>
                <div class="ml-auto mt-auto">{{ minSpendText }}</div>
            </div>
        </div>
    </div>
</template>